import { Theme } from '@infotech-soe/erp-ui-kit';
import { createUseStyles } from 'react-jss';

export const useItemStyles = createUseStyles(({ colors, sizes }: Theme) => ({
  item: {
    composes: 'flex items-center justify-center text-bold',
    height: sizes.systemNotification.height,
  },
  upgrade: {
    composes: '$item',
    backgroundColor: colors.backgroundNotificationUpgrade,
    color: colors.typoNotificationUpgrade,
  },
  maintenance: {
    composes: '$item',
    backgroundColor: colors.backgroundNotificationMaintenance,
    color: colors.typoNotificationMaintenance,
  },
}));
